// src/lib/heroGrids.js
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  limit,
  orderBy,
  query,
  updateDoc,
  where,
} from 'firebase/firestore'
import { db } from '../firebase'

const COLLECTION = 'heroGrids'

export async function fetchActiveHeroGrids(limitCount = 1) {
  const q = query(
    collection(db, COLLECTION),
    where('isActive', '==', true),
    orderBy('position', 'asc'),
    limit(limitCount)
  )
  const snap = await getDocs(q)
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
}

// --- CRUD pour l’admin ---

export async function listHeroGrids() {
  const snap = await getDocs(
    query(collection(db, COLLECTION), orderBy('position', 'asc'))
  )
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
}

export async function addHeroGrid(data = {}) {
  const ref = await addDoc(collection(db, COLLECTION), {
    mainTitle: '',
    mainSubtitle: '',
    mainImageUrl: '',
    mainHref: '/catalog',
    mainCtaLabel: 'Learn more',
    mainBgColor: '#006d38',

    // 4 cartes à droite
    tile1Title: '',
    tile1Subtitle: '',
    tile1ImageUrl: '',
    tile1Href: '/catalog',

    tile2Title: '',
    tile2Subtitle: '',
    tile2ImageUrl: '',
    tile2Href: '/catalog',

    tile3Title: '',
    tile3Subtitle: '',
    tile3ImageUrl: '',
    tile3Href: '/catalog',

    tile4Title: '',
    tile4Subtitle: '',
    tile4ImageUrl: '',
    tile4Href: '/catalog',

    position: 1,
    isActive: true,
    ...data,
  })
  const snap = await getDoc(ref)
  return { id: snap.id, ...snap.data() }
}

export async function updateHeroGrid(id, data) {
  const ref = doc(db, COLLECTION, id)
  await updateDoc(ref, data)
}

export async function deleteHeroGrid(id) {
  const ref = doc(db, COLLECTION, id)
  await deleteDoc(ref)
}
